<form [formGroup]="mobileNumberForm">
  <div class="rs-form-item">
    <div class="rs-flex-row rs-flex-collapse rs-flex-middle">
      <div class="rs-flex-column">
        <input
          type="text"
          name="mobileNumber"
          id="mobileNumber"
          formControlName="mobileNumber"
          autocomplete="off"
          maxlength="10"
          [ngClass]="{ 'rs-filled': !isNumberEmpty() }"
        /><label for="mobileNumber" class="rs-form-label">{{
          'sms.validation.mobile.number.placeholder' | translate
        }}</label>
      </div>
    </div>
  </div>

  <mprd-mobile-number-errors
    [errors]="mobileNumberForm.get('mobileNumber').errors"
    *ngIf="isMobileNumberInputFormHasErrors"
  ></mprd-mobile-number-errors>
</form>
